import React, { PropsWithChildren } from 'react';

import { QueryClientProvider } from '@tanstack/react-query';

import { LoadingScreen } from '@/components/loading/LoadingScreen.tsx';
import { CriticalErrorPage } from '@/pages/CriticalErrorPage.tsx';
import { queryClient } from '@/queries/Queries.ts';
import { QueryAwait } from '@/queries/QueryAwait.tsx';

export const QueriesWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <QueryAwait
        errorFallback={CriticalErrorPage}
        pendingFallback={LoadingScreen}
      >
        {children}
      </QueryAwait>
    </QueryClientProvider>
  );
};
